import wrapper from 'wrapper';
import events from '../scrolly-library/events-emitter';

class AnimationToggle {
    constructor() {
        this.toggle = wrapper.select('.animation-toggle');
        this.toggle.addEventListener('change', e => {
            events.emit('animation-toggled', e.target.checked);
            if (e.target.checked) {
                wrapper.select('.toggle-label').textContent = __('animation_toggle_enabled');
                this.enableAnimatedImages();
            }
            else {
                wrapper.select('.toggle-label').textContent = __('animation_toggle_disabled');
                this.disableAnimatedImages();
            }
        });
    }

    init() {
        // disable animation by default is prefers-reduced-motion enabled
        // otherwise set to enabled, prevents mismatch on reload if user checked and refreshed
        const checkbox = this.toggle.querySelector('input');
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;
        checkbox.checked = !prefersReducedMotion;
        wrapper.select('.toggle-label').textContent = checkbox.checked ? __('animation_toggle_enabled') : __('animation_toggle_disabled');
        events.emit('animation-toggled', checkbox.checked);
    }

    enableAnimatedImages() {
        const firstAnimatedImg = wrapper.select('.scroller-image');
        if (!firstAnimatedImg.classList.contains('animated')) {
            wrapper.selectAll('.scroller-image').forEach((img) => img.classList.add('animated'));
        }
        wrapper.selectAll('.fade-chart').forEach((el) => {
            el.classList.add('animated');
        });
        wrapper.select('canvas').classList.add('animated');
    }

    disableAnimatedImages() {
        wrapper.selectAll('.scroller-image').forEach((img) => {
            img.classList.remove('animated');
        });
        wrapper.selectAll('.fade-chart').forEach((el) => {
            el.classList.remove('animated');
        });
        wrapper.select('canvas').classList.remove('animated');
        // wrapper.select('.scroll__cta').classList.remove('animated');
    }
}

export default AnimationToggle;
